module.exports = __webpack_public_path__ + "static/media/ac2.34ffed25.jpg";